export default __webpack_public_path__ + "static/media/Supplier_Product_Promotion_0111_3112_2025.4a0ba3a2.xlsx";